<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Utilisateurs</span>
        <template v-if="$route.name === 'user-profile'">
          <h3 class="page-title">{{ $t("user.my.profile") }}</h3>
        </template>
        <template v-else>
          <h3 class="page-title">{{ $t("user.profile") }}</h3>
        </template>
      </d-col>
    </d-row>

    <!-- Content -->
    <d-row v-if="user">
      <d-col lg="4">
        <upl-user-details
          :userDetails.sync="user"
          @updateProfile="updateProfile"
          :editable="editable"
        />
      </d-col>
      <d-col lg="8">
        <upl-user-account-details
          :userDetails.sync="user"
          :editable="editable"
        />
      </d-col>
    </d-row>
    <d-row v-if="checkIfCanEdit()">
      <d-col lg="12">
        <d-card class="card-small user-activity mb-4">
          <!-- Card Header -->
          <d-card-header class="border-bottom">
            <h6 class="m-0">Historique des demandes</h6>
            <div class="block-handle"></div>
          </d-card-header>

          <!-- Activity Items -->
          <d-card-body class="p-0">
            <history-days-off :reference="user.reference" />
            <history-simple-absence :reference="user.reference" />
            <history-recovery-request :reference="user.reference" />
            <history-recovery-time :reference="user.reference" />
          </d-card-body>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import UserDetails from '@/components/user/profile/UserDetails.vue';
import UserAccountDetails from '@/components/user/profile/UserAccountDetails.vue';
import HistoryRecoveryRequest from '../../components/abscenceRequest/HistoryRecoveryRequest';
import HistoryRecoveryTime from '../../components/abscenceRequest/HistoryRecoveryTime';
import HistorySimpleAbsence from '../../components/abscenceRequest/HistorySimpleAbsence';
import HistoryDaysOff from '../../components/abscenceRequest/HistoryDaysOff';

import { checkIfCanEditUser } from '../../utils/Rules.js';

export default {
  name: 'user-profile',
  components: {
    HistoryDaysOff,
    HistorySimpleAbsence,
    HistoryRecoveryTime,
    HistoryRecoveryRequest,
    uplUserDetails: UserDetails,
    uplUserAccountDetails: UserAccountDetails,
  },
  data() {
    return {
      user: null,
      editable: false,
    };
  },
  mounted() {
    if (this.$route.name === 'user-profile') {
      this.$services.user.myAccount().then((res) => {
        this.user = res.data;
        this.editable = true;
      });
    } else {
      this.$services.user
        .findByReference(this.$route.params.reference)
        .then((res) => {
          this.user = res.data;
        });
    }
  },
  methods: {
    updateProfile(user) {
      this.user = user;
    },
    checkIfCanEdit() {
      return !checkIfCanEditUser(
        this.$store.state.user.informations,
        this.user,
      );
    },
  },
};
</script>

